import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { skip } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ViewService {
	constructor(
		private router: Router
	) { }

	RefreshViewByTrigger(trigger$: Observable<any>, routeDataKey: string): Subscription {
		return trigger$
			.pipe(skip(1))
			.subscribe(() => {
				if (!this.currentRouteHasData(routeDataKey))
					return;

				this.refreshCurrentRoute();
			});
	}

	refreshCurrentRoute(): Promise<boolean> {
		const url = this.router.url;
		return this.router.navigateByUrl('/', {
			skipLocationChange: true
		}).then(() => {
			return this.router.navigateByUrl(url);
		});
	}

	currentRouteHasData(key: string): boolean {
		let route = this.router.routerState.snapshot.root;
		while (route.firstChild) {
			route = route.firstChild;
			if (route.data?.[key]) {
				return true;
			}
		}
		return false;
	}
}

